module.exports = __webpack_public_path__ + "img/agencyList_empty.e4d64325.png";